import { useState } from 'react';
import '../styles/ForgotPassword.css';
import { FaEnvelope, FaExclamationCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import CommonButton from '../components/CommonButton';
import CustomFormGroup from '../components/CustomFormGroup';
import { emailResetPassword } from '../services/api/authService';
import { useLoading } from "../components/LoadingContext";

const ForgotPasswordPage = () => {
  const [form, setForm] = useState({ email: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [touched, setTouched] = useState({});
  const { showLoading, hideLoading } = useLoading();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validate = () => {
    const errors = {};
    if (!form.email) errors.email = 'Email is required';
    return errors;
  };

  const errors = validate();
  const isValid = Object.keys(errors).length === 0;

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!isValid) {
      setTouched({ email: true });
      return;
    }

    showLoading();
    try {
      const result = await emailResetPassword(form.email);

      if (result.success) {
        setSuccess('Password reset link has been sent to your email.');
      } else {
        setError(result.message);
      }
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      hideLoading();
    }
  };



  return (
    <div className="forgot-password-page">
      <div className="forgot-password-container">
        <h2 className="forgot-password-title">Forgot Your Password?</h2>

        <form onSubmit={handleForgotPassword} noValidate>
          <CustomFormGroup
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Email"
            icon={<FaEnvelope />}
            error={touched.email && errors.email}
          />

          {error && (
            <div className="forgot-password-error">
              <FaExclamationCircle /> {error}
            </div>
          )}

          {success && (
            <div className="forgot-password-success">
              {success}
            </div>
          )}

          <CommonButton type="submit">Reset Password</CommonButton>
        </form>

        <div className="forgot-password-links">
          <Link to="/">Back To Login</Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
